import { render } from "./VAlerts.vue?vue&type=template&id=c6061db8&scoped=true"
import script from "./VAlerts.vue?vue&type=script&lang=js"
export * from "./VAlerts.vue?vue&type=script&lang=js"

import "./VAlerts.vue?vue&type=style&index=0&id=c6061db8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6061db8"]])

export default __exports__